module.exports = __webpack_public_path__ + "img/kovatek-home.e0b981c0.png";